export default __webpack_public_path__ + "static/media/red_right.ddcd1278.svg";